import React from "react";
import SettingsForm from "../SettingsForm";

const fields = [
  { heading: "Requests list" },
  { key: "cases_heading", label: "Heading" },
  { key: "cases_intro", label: "Intro text", type: "textarea" },
  { heading: "Registration form" },
  { key: "register_intro", label: "Text shown above the registration form", type: "textarea", rows: 5 },
  { heading: "Help window" },
  {
    key: "help_instructions", label: "How people should send their help", type: "textarea", rows: 6,
    hint: "Shown to every helper - e.g. your bank account, JazzCash / Easypaisa number, or where to drop goods.",
  },
  { key: "currency_label", label: "Currency label", hint: "Shown before every amount, e.g. PKR, USD, AED." },
];

export default function FoundationContentSettings() {
  return (
    <SettingsForm
      endpoint="/core/foundation/settings/"
      title="Foundation Content"
      intro="The texts of the Foundation page. The banner, the body and the browser title are managed under 'Banner & Body'."
      fields={fields}
    />
  );
}
